import { useQuery } from '@tanstack/react-query'
import { fetchRelease } from '@infrastructure/api/releaseApi'
import { VERSION_QUERY_KEY } from './queryKeys'

export { VERSION_QUERY_KEY } from './queryKeys'
export { useVersionMismatch } from '@shared/hooks/useVersionMismatch'

export function useVersionQuery() {
  return useQuery({
    queryKey: VERSION_QUERY_KEY,
    queryFn: fetchRelease,
    staleTime: 10 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
    retry: false,
  })
}
